import {SnackbarStoreType} from "./storeTypes";

export const SnackbarDefaultStore: SnackbarStoreType = {
	open: false,
	message: "",
	color: ""
}
